import(/* webpackMode: "eager" */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/app/global-error.tsx");
